import { useEffect, useRef, useState } from "react";

export function SignaturePad({ onChange, testid = "signature-pad", height = 140 }) {
  const ref = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [empty, setEmpty] = useState(true);
  useEffect(() => {
    const c = ref.current; const ctx = c.getContext("2d");
    c.width = c.offsetWidth * 2; c.height = height * 2; ctx.scale(2, 2);
    ctx.lineWidth = 2.2; ctx.lineCap = "round"; ctx.strokeStyle = "#0A1426";
  }, [height]);
  const pos = (e) => { const r = ref.current.getBoundingClientRect(); return [e.clientX - r.left, e.clientY - r.top]; };
  const start = (e) => { e.preventDefault(); ref.current.setPointerCapture?.(e.pointerId); const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.beginPath(); ctx.moveTo(x, y); setDrawing(true); };
  const move = (e) => { if (!drawing) return; e.preventDefault(); const ctx = ref.current.getContext("2d"); const [x, y] = pos(e); ctx.lineTo(x, y); ctx.stroke(); if (empty) setEmpty(false); };
  const end = () => { if (!drawing) return; setDrawing(false); onChange?.(ref.current.toDataURL("image/png")); };
  const clear = () => { const c = ref.current; c.getContext("2d").clearRect(0, 0, c.width, c.height); setEmpty(true); onChange?.(null); };
  return (
    <div>
      <canvas ref={ref} data-testid={testid} style={{ height, touchAction: "none" }} className="w-full rounded-xl border-2 border-dashed border-[#E4E0D5] bg-white cursor-crosshair"
        onPointerDown={start} onPointerMove={move} onPointerUp={end} onPointerLeave={end} />
      <div className="flex justify-between items-center mt-1 text-[11px] text-[#0A1426]/60">
        <span>{empty ? "Signez au doigt ou à la souris" : "Signature tracée"}</span>
        <button type="button" data-testid={`${testid}-clear`} onClick={clear} className="underline">Effacer</button>
      </div>
    </div>
  );
}
